<script lang="ts">
  import { onMount } from "svelte";

  import DwollaAcknowledgmentsModal from "@retailer/svelte/Payments/DwollaAcknowledgmentsModal.svelte";

  import { PlaidCustomization } from "@retailer/types/Plaid";

  import * as BankAccountService from "@retailer/services/bank_account_service";
  import * as DwollaAcknowledgmentsService from "@retailer/services/dwolla_acknowledgments_service";

  import { dwollaAcknowledgmentsStore } from "@retailer/svelte/stores/DwollaAcknowledgmentsStore";
  import type { BankAccountMetaData } from "@retailer/stores/BankAccountStore";

  export let afterSuccess: (metadata: BankAccountMetaData) => void;
  export let afterExit = () => {};
  export let onLoad = () => {};
  export let customization: PlaidCustomization = PlaidCustomization.Default;

  let plaidModalBuilt = false;
  let plaidModal: any;
  let showDwollaAcknowledgmentsModal = false;

  const onDwollaAcknowledgmentsModalClose = () => {
    showDwollaAcknowledgmentsModal = false;
    afterExit();
  };

  const onDwollaAcknowledgmentsAccept = async () => {
    await DwollaAcknowledgmentsService.create();
    showDwollaAcknowledgmentsModal = false;
  };

  onMount(() => {
    (async () => {
      await DwollaAcknowledgmentsService.get();
    })();

    BankAccountService.buildPlaidModal({
      customization,
      afterSuccess,
      afterExit,
      onLoad,
    }).then(res => {
      if (res) {
        plaidModalBuilt = true;
        plaidModal = res;
      }
    });
  });

  $: dwollaAcknowledgmentsAccepted = $dwollaAcknowledgmentsStore.dwollaAcknowledgments?.length > 0;
  $: if (plaidModalBuilt) {
    if (dwollaAcknowledgmentsAccepted) {
      plaidModal?.open();
    } else {
      showDwollaAcknowledgmentsModal = true;
    }
  }

</script>

<div data-testid="plaid-modal" />

{#if showDwollaAcknowledgmentsModal}
  <DwollaAcknowledgmentsModal
    onClose={onDwollaAcknowledgmentsModalClose}
    onAccept={onDwollaAcknowledgmentsAccept}
  />
{/if}
